// extracted by mini-css-extract-plugin
module.exports = {"main":"BuyToken_main__2yQpx","btnCntnr":"BuyToken_btnCntnr__1zLqS"};